import './search-input.scss';

// Assets
import { ReactComponent as SearchIcon } from '../../asset/search.svg';

const SearchInput = ({ disabled, onSearch, ...rest }) => {
	return (
		<div className={'search-input' + (disabled ? ' disabled' : '')}>
			<div className="search-input__wrapper">
				<input type="text" className="search-input__input" {...rest} />
				<div className="search-input__icon" onClick={() => !disabled && onSearch()}>
					<SearchIcon />
				</div>
			</div>
		</div>
	);
};

export default SearchInput;
